import { useMsal } from '@azure/msal-react';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import {
  UserCircleIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';
import { useChatStore } from '../stores/chatStore';

export default function Header() {
  const { instance, accounts } = useMsal();
  const { currentUser, clearChat } = useChatStore();

  const handleLogout = () => {
    clearChat();
    instance.logoutRedirect({
      postLogoutRedirectUri: '/join',
    });
  };

  const displayName = currentUser?.displayName || accounts[0]?.name || 'User';

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src="/simplytechwise-logo.png" alt="Simply TechWise" className="h-10" />
            <span className="text-lg font-semibold text-wise-dark">
              WiseAssist
              <sub className="text-xs text-gray-500 ml-1">v{import.meta.env.VITE_APP_VERSION || '0.1.1'}</sub>
            </span>
          </div>

          {/* User Menu */}
          <Menu as="div" className="relative">
            <Menu.Button className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors btn-touch">
              <UserCircleIcon className="h-6 w-6 text-gray-500" />
              <span className="hidden sm:block text-gray-700 font-medium">{displayName}</span>
              <Bars3Icon className="h-5 w-5 text-gray-400 sm:hidden" />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none p-1">
                <div className="px-3 py-2 border-b border-gray-100 mb-1">
                  <p className="text-sm font-medium text-gray-900">{displayName}</p>
                  <p className="text-xs text-gray-500 truncate">{accounts[0]?.username}</p>
                </div>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-gray-100' : ''
                      } flex items-center gap-3 w-full px-3 py-2 text-sm text-gray-700 rounded-lg`}
                    >
                      <Cog6ToothIcon className="h-5 w-5 text-gray-400" />
                      Settings
                    </button>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLogout}
                      className={`${
                        active ? 'bg-red-50' : ''
                      } flex items-center gap-3 w-full px-3 py-2 text-sm text-red-600 rounded-lg`}
                    >
                      <ArrowRightOnRectangleIcon className="h-5 w-5" />
                      Sign Out
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </header>
  );
}
